module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-redes-sociais-facebook.caf9a7a7.jpg";